/* CarbonTree helpers (2026-07-16): sticky split bar size guard.
   The "Select Size" microcopy is SERVER-RENDERED in the sticky
   buttons and toggled by pure CSS (body:has checked radio) — no JS
   involvement, so it paints instantly with the page.
   2026-07-20: bundle/app templates (yt-combo, mix-and-match,
   pre-launch-sets) get a single full-width sticky Add to cart that
   presses the bundle app's own CTA. No Buy Now there (Shiprocket has
   no cart-level checkout on this store — verified, do not re-add). */
function ctExplicitSize() {
  const checked = document.querySelector(
    ".wt-product__main .f-button__list input[type='radio']:checked"
  );
  return checked ? String(checked.value || "").trim() : "";
}
function ctJumpToSizes() {
  const list = document.querySelector(".wt-product__main .f-button__list");
  if (!list) return;
  list.scrollIntoView({ behavior: "smooth", block: "center" });
  list.classList.add("ct-size-attn");
  setTimeout(() => list.classList.remove("ct-size-attn"), 1800);
}
function ctMainAtcBtn() {
  return document.querySelector(
    ".wt-product__add-to-cart_form--wrapper .js-add-to-cart"
  );
}

class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    this.activeClass = "wt-product__sticky-buy--show";
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    const addToCartModule =
      document.querySelector(".wt-product__add-to-cart") ||
      document.querySelector(".wt-product__main");
    const btn = this.querySelector(".js-add-to-cart");
    const hasSizeList = !!document.querySelector(
      ".wt-product__main .f-button__list"
    );
    if (!hasSizeList) {
      this.querySelectorAll(".ct-sub").forEach((s) => s.remove());
    }

    // Bundle/app templates (yt-combo, mix-and-match, pre-launch-sets)
    // have no theme buy-box form — the cart flow belongs to the
    // bundles app. There the bar is a single full-width Add to cart
    // that presses the app's own CTA (scrolled into view first so any
    // "pick your items" message from the app is seen). No Buy Now:
    // Shiprocket has no cart-level checkout on this store. The form
    // wrapper is server-rendered, so this check is race-free.
    if (
      !document.querySelector("main .wt-product__add-to-cart_form--wrapper")
    ) {
      const bn0 = this.querySelector(".ct-sticky-buynow");
      if (bn0) {
        // !important: the mobile media query sets display:flex on it.
        bn0.style.setProperty("display", "none", "important");
      }
      // When the browser restores a bundle page from the back/forward
      // cache after an add, the bundle app's widget wakes up with
      // stale state and the item picker doesn't come back. Force a
      // fresh load on bfcache restores — bundle pages only.
      window.addEventListener("pageshow", (ev) => {
        if (ev.persisted) window.location.reload();
      });
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const appBtn =
          [
            ...document.querySelectorAll(
              "main .yt-comboBundle-bundle-cta-button, main .yt-mixMatch-add-to-cart-button"
            ),
          ].find((b) => b.offsetParent) || null;
        if (!appBtn) {
          if (addToCartModule) {
            addToCartModule.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
          return;
        }
        appBtn.scrollIntoView({ behavior: "smooth", block: "center" });
        // The app adds to cart but never opens the drawer (and doesn't
        // reliably refresh it either — measured 2026-07-20). So: after
        // the click, confirm the cart grew (one check + one retry, no
        // polling — /cart.js rate-limits), then re-render the drawer
        // and open it. If the app rejected the add (items not picked),
        // the cart won't grow and its own message shows at the CTA.
        const drawerIsOpen = () =>
          document.body.classList.contains("page-overlay-cart-on");
        const countBefore = fetch("/cart.js")
          .then((r) => (r.ok ? r.json() : null))
          .then((c) => (c ? c.item_count : null))
          .catch(() => null);
        appBtn.click();
        const openDrawer = () => {
          // Fetch fresh drawer markup FIRST, render it, THEN open —
          // the same order the theme uses for its own adds. Opening
          // before the refresh lands flashes an empty drawer.
          fetch("/?sections=cart-drawer,cart-icon-bubble")
            .then((r) => (r.ok ? r.json() : null))
            .then((sections) => {
              const drawer = document.querySelector("cart-drawer");
              if (
                sections &&
                drawer &&
                typeof drawer.renderContents === "function"
              ) {
                drawer.renderContents({ sections: sections }, false);
                if (
                  !drawerIsOpen() &&
                  typeof drawer.toggleDrawerClasses === "function"
                ) {
                  drawer.toggleDrawerClasses();
                }
              } else {
                // Fallback: theme refresh event, then open once it has
                // had time to land.
                document.dispatchEvent(new Event("cart-drawer:refresh"));
                setTimeout(() => {
                  if (drawerIsOpen()) return;
                  const t = document.querySelector(".wt-cart__trigger");
                  if (t) t.click();
                }, 900);
              }
            })
            .catch(() => {});
        };
        let checks = 0;
        const check = () => {
          checks++;
          Promise.all([
            countBefore,
            fetch("/cart.js")
              .then((r) => (r.ok ? r.json() : null))
              .then((c) => (c ? c.item_count : null))
              .catch(() => null),
          ]).then(([b, a]) => {
            if (b != null && a != null && a > b) {
              openDrawer();
            } else if (checks < 2) {
              setTimeout(check, 2200);
            }
          });
        };
        setTimeout(check, 1600);
      });
      return;
    }

    const forObserver = document.querySelectorAll(
      ".wt-product__add-to-cart_form--wrapper, .wt-product__name"
    );

    let intersected = [];
    let passedBuyBox = false;

    // ADD TO CART: requires an explicit size — otherwise jump to the
    // size picker. With a size, delegate to the main form's button.
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (hasSizeList && !ctExplicitSize()) {
        ctJumpToSizes();
        return;
      }
      const mainBtn = ctMainAtcBtn();
      if (
        mainBtn &&
        !mainBtn.disabled &&
        !mainBtn.classList.contains("disabled") &&
        !/sold|unavailable/i.test(mainBtn.textContent)
      ) {
        mainBtn.click();
      } else if (addToCartModule) {
        addToCartModule.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });

    // BUY NOW: prefer the server-rendered button (instant paint);
    // create it only as a fallback for templates not yet updated.
    let buyNowBtn = this.querySelector(".ct-sticky-buynow");
    if (!buyNowBtn) {
      buyNowBtn = document.createElement("button");
      buyNowBtn.type = "button";
      buyNowBtn.className = "ct-sticky-buynow";
      const bnLabel = document.createElement("span");
      bnLabel.className = "ct-bn-label";
      bnLabel.textContent = "Buy now";
      buyNowBtn.appendChild(bnLabel);
      this.appendChild(buyNowBtn);
    }

    buyNowBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (hasSizeList && !ctExplicitSize()) {
        ctJumpToSizes();
        return;
      }
      const wraps = [
        ...document.querySelectorAll(
          "main form.wt-product__add-to-cart_form .shiprocket-headless"
        ),
      ];
      const visible = wraps.find((d) => d.offsetParent);
      const target =
        (visible && visible.querySelector("button")) ||
        document.querySelector("main .shiprocket-headless button");
      if (target) {
        target.click();
      } else if (addToCartModule) {
        addToCartModule.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const { isIntersecting, target } = entry;
        isIntersecting
          ? intersected.push(target)
          : (intersected = intersected.filter((item) => item !== target));

        if (
          target.classList.contains("wt-product__add-to-cart_form--wrapper")
        ) {
          passedBuyBox =
            !isIntersecting && entry.boundingClientRect.top < 0;
        }
      });

      if (intersected.length || !passedBuyBox) {
        this.classList.remove(this.activeClass);
      } else {
        this.classList.add(this.activeClass);
      }
    });

    forObserver.forEach((item) => {
      observer.observe(item);
    });
  }
}

customElements.define("sticky-buy-button", StickyBuyButton);

if (!customElements.get("gallery-fashion")) {
  customElements.define(
    "gallery-fashion",
    class GalleryFashion extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section");
        this.logoBanner = this;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.removeEventsWhenDesignMode();
      }

      addEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.addEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      removeEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.removeEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.removeEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      reinitAfterDelay() {
        setTimeout(() => this.reinit(), 0);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector("#root");
        const firstSection = sectionWrapper.querySelector("section");
        this.section = this.closest("section");
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      handleResize() {
        this.setTopMargin();
        this.positioningProductInfo();
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--fashion-transparent";

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 },
        );

        observer.observe(this.querySelector(".wt-product__gallery"));
      }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header.offsetHeight;
        const offset =
          this.isTransparentHeaderEnabled() && this.isFirstSection()
            ? headerHeight
            : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (offset) {
          this.section.style.marginTop = `-${offset}px`;
        } else {
          this.section.style.marginTop = 0;
        }
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector(".wt-header");
        return (
          header.dataset.transparent &&
          header.classList.contains("wt-header--v3")
        );
      }

      renderProgressBar() {
        const thumbsGallery = this.querySelector("[data-thumbs]");
        const progressBarElement = document.createElement("div");
        progressBarElement.classList.add("gallery-fashion__progress-bar");
        const progressBarIndicatorElement = document.createElement("div");
        progressBarIndicatorElement.classList.add(
          "gallery-fashion__progress-bar-indicator",
        );
        progressBarElement.appendChild(progressBarIndicatorElement);
        thumbsGallery.appendChild(progressBarElement);

        function updateProgressBar() {
          const images = this.querySelector("gallery-section");
          const progressBar = progressBarIndicatorElement;

          const scrolled = window.scrollY;
          const maxHeight = images.clientHeight - window.innerHeight;
          const scrollPercentage = (scrolled / maxHeight) * 100;

          const progressBarHeight = progressBarElement.clientHeight;
          const progressHeight = progressBar.clientHeight;
          const maxProgressTop = progressBarHeight - progressHeight;
          const progressTop = Math.min(
            (scrollPercentage / 100) * maxProgressTop,
            maxProgressTop,
          );

          progressBar.style.top = `${progressTop}px`;

          if (progressTop === maxProgressTop) {
            thumbsGallery.classList.add("finished");
          } else {
            thumbsGallery.classList.remove("finished");
          }
        }

        window.addEventListener("scroll", updateProgressBar.bind(this));

        function handleThumbsClick(event) {
          if (event.target.className === "wt-product__img") {
            const thumbnails = Array.from(
              event.currentTarget.querySelectorAll("img"),
            );
            const index = thumbnails.indexOf(event.target);

            const fullImage = this.querySelectorAll(
              ".wt-masonry__wrapper .wt-product__img, .wt-masonry__wrapper .wt-product__thumbnail-video",
            )[index];

            fullImage.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        thumbsGallery.addEventListener("click", handleThumbsClick.bind(this));
      }

      positioningProductInfo() {
        const productInfo = this.querySelector(".wt-product__main");
        const mediaDesktop = window.matchMedia("(min-width: 1200px)");

        if (mediaDesktop.matches) {
          productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
        }

        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (mediaDesktop.matches) {
              productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
            }
          }
        });

        const observedElement = productInfo;
        resizeObserver.observe(observedElement);
      }

      attachEvents() {
        window.addEventListener("resize", this.handleResize.bind(this));
      }

      init() {
        this.reinitAfterDelay = this.reinitAfterDelay.bind(this);
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
          this.attachEvents();
        }

        this.renderProgressBar();
        this.positioningProductInfo();
        this.addEventsWhenDesignMode();
      }

      reinit() {
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
        }
        this.positioningProductInfo();
      }
    },
  );
}


document.addEventListener("DOMContentLoaded", function () {
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const tab = this.getAttribute('data-tab');

    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active-color'));
    this.classList.add('active-color');

    document.querySelectorAll('.wt-product__option__body').forEach(content => {
      if (content.getAttribute('data-tab') === tab) {
        content.classList.add('active-tab');
      } else {
        content.classList.remove('active-tab');
      }
    });
  });
});
});